import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { ITelemetryLogger } from '@cian/telemetry/shared';
import { ICheckServiceRequest } from '../../repositories/billing-tariffs/v3/check-service';
import { ICheckoutInfo, ECheckServiceErrorCode } from '../../types/reducers/checkoutInfo';
import { EServiceId } from '../../types/reducers/publishTerms';

export interface ICheckServiceParams {
  httpApi: IHttpApi;
  logger: ILogger;
  telemetry: ITelemetryLogger;
  parameters: ICheckServiceRequest;
}

export type TCheckServiceResult = ICheckServiceSuccess | ICheckServiceFail;

export interface ICheckServiceAuction {
  previousBets: number[];
  nextBets: number[];
  currentBet: number;
}

export interface ICheckServiceBalance {
  auctionPoints: number;
  totalBalance: number;
  canFill: boolean;
}

export interface ICheckServiceSuccess {
  success: true;
  payload: ICheckoutInfo;
  selectedPromotionInfo: ISelectedPromotionInfo;
  auction: ICheckServiceAuction;
  balance: ICheckServiceBalance;
  recommendedDepositAmount: number;
}

export interface ICheckServiceFail {
  success: false;
  payload: ECheckServiceErrorCode;
}

export interface ISelectedPromotionInfo {
  publicationType: ECheckServicePublicationType;
  promotionType: ECheckServicePromotionType;
  promotionTypeChangeReason: null | string;
  serviceId: EServiceId;
}

export enum ECheckServicePromotionType {
  // без продвижения
  noPromotion = 'noPromotion',
  // продвижение топ
  top = 'top',
  // продвижение премиум
  premium = 'premium',
  // продвижение стандарт
  standard = 'standard',
}

export enum ECheckServicePublicationType {
  PromotionPackage = 'promotionPackage',
  PublicationPackage = 'publicationPackage',
  Publication = 'publication',
}
